<template>
  <div class="p-fluid">    
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="firstName">First Name*</label>
        <InputText
          class="clearer"
          id="firstName"
          v-model.trim="contact.firstName"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="lastName">Surname*</label>
        <InputText
          class="clearer"
          id="lastName"
          v-model.trim="contact.lastName"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="salutation">Job Function</label>
        <InputText
          v-if="contact.jobFunction"
          class="clearer"
          id="salutation"
          v-model.trim="contact.jobFunction.jobFuncName"
          required="false"
          autofocus
          :disabled="true"
        />
        <InputText
          v-else
          class="clearer"
          id="salutation"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col p-col-8">
        <label for="jobTitle">Select Customer</label>
        <InputText
          class="clearer"
          placeholder=""
          :disabled="true"
          v-model="contact.custName"
        >
        </InputText>
      </div>
      <div class="p-field p-col p-col-4">
        <label for="jobTitle">Job Title</label>
        <InputText
          class="clearer"
          id="jobTitle"
          v-model.trim="contact.contactJobTitle"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="address1">House</label>
        <InputText
          class="clearer"
          id="address1"
          v-model.trim="contact.address1"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="address2">Street</label>
        <InputText
          class="clearer"
          id="address2"
          v-model.trim="contact.address2"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="address3">Sub Area</label>
        <InputText
          class="clearer"
          id="address3"
          v-model.trim="contact.address3"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="address4">City/Town</label>
        <InputText
          class="clearer"
          id="cityTown"
          v-model.trim="cityTown.cityTownName"
          required="false"
          autofocus
          :disabled="true"
        />
        <!-- <InputText
          class="clearer"
          id="address4"
          v-model.trim="contact.address4"
          required="false"
          autofocus
          :disabled="true"
        /> -->
      </div>
      <div class="p-field p-col">
        <label for="postCode">Post Code</label>
        <InputText
          class="clearer"
          id="postCode"
          v-model.trim="contact.postCode"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <!-- <div class="p-field p-col">
        <label for="country">Country</label>
        <InputText
          class="clearer"
          id="country"
          v-model.trim="contact.country"
          required="false"
          autofocus
          :disabled="true"
        />
      </div> -->
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="phoneNo">Phone No</label>
        <InputText
          class="clearer"
          id="phoneNo"
          v-model.trim="contact.phoneNo"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="mobile">Mobile</label>
        <InputText 
          class="clearer"
          id="mobile" 
          v-model.trim="contact.mobile" 
          required="false" 
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="email">Email</label>
        <InputText 
          class="clearer"
          id="email" 
          v-model.trim="contact.email" 
          required="false" 
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="lastContactDate">Last Call Date</label>
        <InputText
          class="clearer"
          id="lastContactDate"
          v-model.trim="contact.lastCallDate"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="nextContactDate">Next Call Date</label>
        <InputText
          class="clearer"
          id="nextContactDate"
          v-model.trim="contact.nextCallDate"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="notes">Notes</label>
        <InputText 
          class="clearer"
          id="notes" 
          v-model.trim="contact.notes" 
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="canEmail">can Email?</label>
        <InputSwitch 
          v-model="contact.canEmail" 
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="canCall">can Call?</label>
        <InputSwitch 
          v-model="contact.canCall" 
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="canMail">can Mail?</label>
        <InputSwitch 
          v-model="contact.canMail" 
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="keyContact">Key Contact?</label>
        <InputSwitch 
          v-model="contact.keyContact" 
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="active">Active?</label>
        <InputSwitch 
          v-model="contact.active" 
          autofocus
          :disabled="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    salutation: {},
    jobTitle: {},
    cityTown: {}
  }),
  created() { 
    this.setupComponent(this.$store.getters['contacts/getContactDetailsForTab'])
  },
  computed: {
    contact() {
      
      return this.$store.getters['contacts/getContactDetailsForTab']
    }
  },
  watch: {
    contact(val) {
      
      this.setupComponent(val)
    }
  },
  methods: {
    setupComponent(val) {
      if (val && val.salutation) {
        this.salutation = val.salutation
      }
      if (val && val.jobTitle) {
        this.jobTitle = val.jobTitle
      }
      if (val && val.cityTown) {
        this.cityTown = val.cityTown
      }
    }
  }
}
</script>

<style>

</style>